import React from "react";
import "./index.css";

const Modal = ({
  imageSrc,
  altText,
  onClose,
  closeBtn,
  closeBtnWidth,
  closeBtnHeight,
}) => {
  return (
    <>
      <div className="modal-overlay" onClick={onClose}></div>
      <div className="modal-content-base">
        <button className="modal-back-button" onClick={onClose}>
          <img
            src={closeBtn}
            alt="close modal button"
            width={closeBtnWidth}
            height={closeBtnHeight}
          />
        </button>
        <div className="modal-line"></div>
        <img src={imageSrc} alt={altText} className="modal-image" />
        <div className="modal-line"></div>
      </div>
    </>
  );
};

export default Modal;
